<div style="display: flex; flex-direction: row; gap: 12px;" (click)="openNoteDetails()">
  
    <div class="report-tight-content">
  <div class="report-title">
             @if (this.note()?.PlayerCurrentTeamIcon!=null) {
                <img style="max-height: 40px; max-width: 40px; margin-right: 5px;" [src]="('../../assets/img/' + this.note()?.PlayerCurrentTeamIcon).replace('//','/').toLowerCase()"    >
            }
            <div style="display: flex; flex-direction: column;width: 100%;">
                <div style="display: flex; flex-direction: row;  ">
                    <a  [routerLink]="['/player/details', this.note()?.PlayerId]" class="report-title linktext">
                    {{ this.note()?.PlayerLastName}}, {{ this.note()?.PlayerFirstName}} 
                    </a>
                    <div class="spacer"></div>
                    <div class="timeago">{{getTimeAgo()}}</div>
                </div>
                <div>
                    <div style="font-size: 10px; font-weight: normal; ">
            @if (this.note()?.PositionId===1) {
                <span style="font-weight: normal;">
                Goaltender -
                </span>
            }
            @if (this.note()?.PositionId===2 || this.note()?.PositionId===3 ) {
                <span >
                Defender -
                </span>
            }
            @if (this.note()?.PositionId ?? 0>3) {
                <span>
                Forward -
                </span>
            }
            <span >

                {{ this.note()?.DateOfBirth | date:'yyyy-MM-dd'}} ({{this.note()?.PlayerAgeYear + ' Years ' + this.note()?.PlayerAgeMonth + ' Months'}})

            </span>
            <br>
                @if (this.note()?.ReportDivision != null && this.note()?.ReportTeamName != null) {
                <span>
                    {{this.note()?.ReportDivision ?? "" + "/" + this.note()?.ReportTeamName}}<br/>
                </span>
                }
                @if (this.note()?.ReportDivision === null || this.note()?.ReportTeamName === null) {
                <span>
                    {{this.note()?.PlayerCurrentDivision ?? "" + "/" + this.note()?.PlayerCurrentTeam}}<br/>
                </span>
                }

                    </div>
                    
                </div>                   
            </div>                        
        </div>
        <div class="ReportText">{{ this.note()?.Text }} </div>
                <!-- META INFO below-->
        <div style="display: flex; flex-direction: column; flex-wrap: wrap; margin-top: 10px;">
             @if (this.note()?.GameText) {
                <div style="display: flex; flex-direction: row;">
                    <mat-icon style="font-size: 18px; height: 18px">sports_hockey</mat-icon>
                    <div style="font-size: 10px;;">
                        {{this.note()?.GameText}} <br/>
                        {{this.note()?.ReportDivision}} - {{this.note()?.GameDate | date:'yyyy-MM-dd'}}
                    </div>
                     
                    <div></div>
                </div>
            }
            <div style="display: flex; flex-direction: row;">
                <div>
                    <mat-icon style="font-size: 18px; height: 18px;;"> location_on</mat-icon>
                </div>
                <div class="metavalue" >
                   {{ this.note()?.Location }}
                </div>
            </div>
              @if (this.note()?.Source) {
                <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                    <div>
                        <mat-icon style=" font-size: 18px; height: 18px;;"> hearing</mat-icon>
                    </div>              
                    <div class="metavalue" >
                        {{this.note()?.Source}}
                    </div>      
                </div>
            }
            <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                <div>
                    <mat-icon style="font-size: 18px; height: 18px;">person</mat-icon>
                </div>
                <div class="metavalue" >
                    {{this.note()?.CreatedByLastName}}, {{this.note()?.CreatedByFirstName}}  
                    <span style="font-size: 10px;">- {{this.note()?.DateCreated | date:'yyyy-MM-dd HH:mm' }}</span>
                </div>
            </div>
          
        </div>
    </div>

</div>